export default {
    REGULAR: 'regular',
    MEDIUM: 'medium',
};
